import { baseApi, resourceScopeTag } from '@krp/client-runtime'
import { decodeNativeReceipt } from './contracts'
import type { NativeReceipt } from '../model/types'
import { OWN_JOURNAL_URLS } from './urls'

const TAG = 'ReceiptsJournal'
export const journalApi = baseApi.enhanceEndpoints({ addTagTypes: [TAG] }).injectEndpoints({ endpoints: (build) => ({
  receiptsNativeDetail: build.query<NativeReceipt, { resourceId: string; id: string }>({ query: ({ resourceId, id }) => ({ url: OWN_JOURNAL_URLS.detail(resourceId, id), decode: decodeNativeReceipt }), providesTags: (_data, _error, args) => [TAG, resourceScopeTag(args.resourceId)] }),
}) })
export const { receiptsNativeDetail } = journalApi.endpoints
